export enum CompanyLegalForm {
    Sro = 'sro',
    As = 'as',
    Gmbh = 'gmbh',
    Ag = 'ag',
    Sarl = 'sarl',
    Sa = 'sa',
    Ltd = 'ltd',
    Llc = 'llc',
    Inc = 'inc',
    Corp = 'corp',
    Srl = 'srl',
    Sl = 'sl',
    SrlIt = 'srl_it',
    Spa = 'spa',
    Kft = 'kft',
    Nv = 'nv',
    Ab = 'ab',
    Asa = 'asa',
    AsEe = 'as_ee',
    Ou = 'ou',
    Ooo = 'ooo',
    Tov = 'tov',
    Vos = 'vos',
    Ks = 'ks',
    Lp = 'lp',
    Llp = 'llp',
    Sole = 'sole',
    Coop = 'coop',
    Foundation = 'foundation',
    Association = 'association',
    Soe = 'soe',
    NotSpecified = 'not_specified',
}

export enum CompanyLegalFormType {
    LimitedLiability = 'limited_liability',
    JointStock = 'joint_stock',
    Partnership = 'partnership',
    SoleProprietorship = 'sole_proprietorship',
    Cooperative = 'cooperative',
    Foundation = 'foundation',
    Association = 'association',
    StateEnterprise = 'state_enterprise',
    Branch = 'branch',
    Insurance = 'insurance',
    Other = 'other',
}

export enum CompanyScopeType {
    AdministrationAccounting = 'administration_accounting',
    SafetyRescueFireOhs = 'safety_rescue_fire_ohs',
    WorkshopHobbyMetalWood = 'workshop_hobby_metal_wood',
    RailTransport = 'rail_transport',
    AirTransport = 'air_transport',
    LandTransport = 'land_transport',
    WaterTransport = 'water_transport',
    TransportServicesInfrastructure = 'transport_services_infrastructure',
    DrugstoreHygiene = 'drugstore_hygiene',
    EcologyEnvironment = 'ecology_environment',
    ElectricalEquipment = 'electrical_equipment',
    ElectricalInstallation = 'electrical_installation',
    ElectricalAppliances = 'electrical_appliances',
    EnergyHeatingPower = 'energy_heating_power',
    FinanceLeasingInsurance = 'finance_leasing_insurance',
    MusicMusicalInstruments = 'music_musical_instruments',
    InteriorFurnishings = 'interior_furnishings',
    ItHardwareElectronics = 'it_hardware_electronics',
    ItSoftwareServices = 'it_software_services',
    OfficeSuppliesPaper = 'office_supplies_paper',
    JewelryWatchesClocks = 'jewelry_watches_clocks',
    LandscapeGardeningPetSupplies = 'landscape_gardening_pet_supplies',
    ForestryLogging = 'forestry_logging',
    MaterialsMetalsChemistry = 'materials_metals_chemistry',
    SeaFishing = 'sea_fishing',
    HuntingGamekeeping = 'hunting_gamekeeping',
    Unclassified = 'unclassified',
    TradeAdvertisingSalesSupport = 'trade_advertising_sales_support',
    WasteRecycling = 'waste_recycling',
    PersonalCareSpa = 'personal_care_spa',
    HospitalityAccommodation = 'hospitality_accommodation',
    FoodBeveragesTobacco = 'food_beverages_tobacco',
    PrecisionInstrumentsOptics = 'precision_instruments_optics',
    RealEstateProperty = 'real_estate_property',
    DistributionWaterElectricityGas = 'distribution_water_electricity_gas',
    Storage = 'storage',
    FoundryMetallurgy = 'foundry_metallurgy',
    JusticeCourtsLaw = 'justice_courts_law',
    ConstructionArchitectureEngineering = 'construction_architecture_engineering',
    MachineryEquipment = 'machinery_equipment',
    MachineryEquipmentParts = 'machinery_equipment_parts',
    MachineryEquipmentWork = 'machinery_equipment_work',
    TelecommunicationsMedia = 'telecommunications_media',
    TextilesClothingFootwearLeather = 'textiles_clothing_footwear_leather',
    MiningQuarries = 'mining_quarries',
    CleaningSanitation = 'cleaning_sanitation',
    ScienceResearchDevelopment = 'science_research_development',
    PublicSocialServices = 'public_social_services',
    MilitaryIndustry = 'military_industry',
    PublishingPrintingPhotography = 'publishing_printing_photography',
    EducationTraining = 'education_training',
    VentilationHeatingPlumbing = 'ventilation_heating_plumbing',
    EntertainmentSportsRecreation = 'entertainment_sports_recreation',
    HealthcareMedicalServices = 'healthcare_medical_services',
    AgriculturePlants = 'agriculture_plants',
    AgricultureAnimals = 'agriculture_animals',
    AgricultureMixed = 'agriculture_mixed',
    Undefined = 'undefined',
}

export enum CompanySize {
    A = 'a',
    B = 'b',
    C = 'c',
    D = 'd',
    E = 'e',
    F = 'f',
}

export enum CompanyStatus {
    Active = 'active',
    ActiveValidated = 'active_validated',
    Blocked = 'blocked',
    BlockedAuto = 'blocked_auto',
    Deleted = 'deleted',
}

export enum CompanyTerminationType {
    Bankrupt = 'bankrupt',
    Terminated = 'terminated',
}

export enum ContactStatus {
    NotValidated = 'not_validated',
    Validated = 'validated',
    Hidden = 'hidden',
    Deleted = 'deleted',
}

export enum ContactType {
    Email = 0,
    Phone = 1,
}

export enum Country {
    Czechia = 'czechia',
}

export enum PersonStatus {
    GdprInactive = 'gdpr_inactive',
    Active = 'active',
    ActiveValidated = 'active_validated',
    Hidden = 'hidden',
    Deleted = 'deleted',
}

export enum UserRole {
    Guest = 'guest',
    User = 'user',
    CompanyAdministrator = 'company_administrator',
    CompanyOwner = 'company_owner',
    Admin = 'admin',
    Superadmin = 'superadmin',
}

export enum UserStatus {
    Active = 'active',
    Inactive = 'inactive',
    ActiveValidated = 'active_validated',
    Blocked = 'blocked',
    BlockedAuto = 'blocked_auto',
    Hidden = 'hidden',
    Deleted = 'deleted',
}
